
export const financebasic = {
  accountcat: {
    service:{
      name:'accountcat',
      title:'Account Category',
    }
  },

  accountstate: {
    service:{
      name:'accountstate',
      title:'Account State',
    }
  },

  accounttype: {
    service:{
      name:'accounttype',
      title:'Account Type',
    }
  },
  accountnature: {
    service:{
      name:'accountnature',
      title:'Account Nature',
    }
  },
  accountfunction: {
    service:{
      name:'accountfunction',
      title:'Account Function',
    }
  },
  accountcashflow: {
    service:{
      name:'accountcashflow',
      title:'Account Cash Flow',
    }
  },
  accountbudget: {
    service:{
      name:'accountbudget',
      title:'Account Budget',
    }
  },
};
